"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.is = void 0;
/**
 * Test that `value` is valid, returning a boolean representing whether it is valid or not.
 * @param guard type-guard to check against
 * @param value value to be checked
 */
function is(guard, value) {
    var iterator = guard.validate(value);
    var done = iterator.next().done;
    return done === true;
}
exports.is = is;
